import { render, staticRenderFns } from "./IntentionJob.vue?vue&type=template&id=18e8d15b&scoped=true"
import script from "./IntentionJob.vue?vue&type=script&lang=js"
export * from "./IntentionJob.vue?vue&type=script&lang=js"
import style0 from "./IntentionJob.vue?vue&type=style&index=0&id=18e8d15b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e8d15b",
  null
  
)

export default component.exports